import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedService } from '../../services/feed.service';
import { ToastService } from 'src/app/core/toast.service';
import { DeletePopupComponent } from 'src/app/modules/dashboard/delete-popup/delete-popup.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-list-newsfeed-category',
  templateUrl: './list-newsfeed-category.component.html',
  styleUrls: ['./list-newsfeed-category.component.scss']
})
export class ListNewsfeedCategoryComponent implements OnInit {
  displayedColumns: string[] = ['sNo', 'category_name', 'created_at', 'updated_at', 'action'];
  dataSource: MatTableDataSource<any>;
  selection = new SelectionModel<any>(true, []);
  totalElements: number = 0;
  offset = { value: 0 };
  limit = { value: 10 };
  category: any[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(private router: Router,
    private route: ActivatedRoute, public feedService: FeedService, private toast: ToastService, private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.getCategories();
  }
  editCategories(category: any) {
    if (category.id) {
      this.router.navigate(['profile', 'list-newsfeed-category', 'edit', category.id], {
        queryParams: { categoryName: category.category_name }
      });
    }
  }
  getCategories() {
    this.feedService.getNewsFeedsCategories().subscribe(data => {
      if (Array.isArray(data)) {
        this.category = [
          {
            category_name: 'Catalog',
            created_at: new Date(),
            updated_at: new Date()
          },
          ...data
        ];
      } else {
        console.error("Expected an array but received:", data);
      }
    }, error => {
      console.error("Error fetching categories:", error);
      this.category = [
        {
          category_name: 'Catalog',
          created_at: new Date(),
          updated_at: new Date()
        }
      ];
    });
  }

  deleteCategories(category: any) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '600px',
      data: {
        item: category,
        name: 'Category'
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response === 'yes') {
        this.feedService.deleteCategories(category.id).then(() => {
          if (category.id) {
            this.getCategories();
            this.toast.openSnackBar('Category deleted successfully');
          }
        });
      }
    });
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  addNewsfeedCategory(): void {
    this.router.navigate(['../add-newsfeeds'], { relativeTo: this.route });
  }
}